import { Injectable } from '@angular/core';
import { LocalStorageItemIDs, LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class MusicModeConfigurationService {
  constructor(private localStorageService: LocalStorageService) {}

  getMusicModeState(): boolean {
    const storedValue = this.localStorageService.getItem(LocalStorageItemIDs.MUSIC_MODE_STATE);
    return storedValue === 'true';
  }

  saveMusicModeState(isEnabled: boolean): void {
    this.localStorageService.setItem(LocalStorageItemIDs.MUSIC_MODE_STATE, isEnabled.toString());
  }
}
